import $ from 'jquery';

function TeamSerieSelectorInit() {
  var selector = '.team-serie-selector';
  var container = '#team-season-serie-selector';
  $(document).on('change', selector, function () {
    var url = $(this).find(':selected').attr('data-url');
    console.log(url);
    $.ajax({
      type: "GET",
      url: url,
      data: {},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        $(container).html(ret);
      }
    });
  });
}

function TeamSeasonSelectorInit() {
  var selector = '.team-season-selector';
  $(document).on('change', selector, function () {
    var url = $(this).find(':selected').attr('data-url');
    window.location = url;
  });
}

function TeamStatSelectorInit() {
  var selector = '.stat-selector';
  $(document).on('change', selector, function () {
    var url = $(this).find(":selected").attr("data-url");
    var container = $(this).find(":selected").attr("data-container");
    $.ajax({
      type: "POST",
      url: url,
      data: {},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        $(container).replaceWith(ret);
      }
    });
  });
}

$(document).ready(function () {
  console.log("init team");
  TeamSerieSelectorInit();
  TeamSeasonSelectorInit();
  TeamStatSelectorInit();
});
